import {displayMultipleAlerts} from "../components/multipleAlerts";
import { om2alert } from "omni-campaign-ui";
import { html } from 'lit';

export const AlertMessagesService = {
    /**
     * Description he `showMultipleAlerts` function takes an array of message objects as input (`inputMessArr`).
     * It then loops through each message object and extracts the `title`, `bodyMsgArr`, and `type`
     * properties. It creates a new object with these properties and adds it to a new array called `messagesArr`.
     * @param {object} inputMessArr
     * @returns his function is responsible for displaying multiple alertson the UI with the specified titles, messages, and types.
     */
    showMultipleAlerts : (inputMessArr) =>{
        let messagesArr = [];
        for(let msgObj of inputMessArr){
            let {title,bodyMsgArr,type, retryBtnText, retryBtnEvent} = msgObj;
            messagesArr.push({
                "bodyMsgArr": bodyMsgArr,title:title, "options":{
                    type: type,
                    retryBtnText,
                    retryBtnEvent
                }
            })
        }
        displayMultipleAlerts({messagesArr,options:{
        }});
    },

    /**
     * Description The `showErrorToastMessage` function is a method of the `AlertMessagesService` object. It takes
     * two parameters: `error_id` and `error_description`. It uses the `om2alert` function from the
     * `omni-campaign-ui` library to display an error message as a toast notification on the UI.
     * @param {object} error_id
     * @param {object} error_description
     * @returns  The `closeTimeout` property is set to 5000 milliseconds, which means that the 
     * toast notification will automatically disappear after 5 seconds. 
     */
    showErrorToastMessage: (error_id, error_description) => {
        om2alert(html`Error - ${error_id} <br> ${error_description}`, {
            type: "danger",
            toast: true,
            closeTimeout: 5000,
        });
    },

    /**
     * Description `showSuccessToastMessage` is a method of the `AlertMessagesService` object that takes a
     * `message` parameter. It uses the `om2alert` function from the `omni-campaign-ui` library to
     * display a success message as a toast notification on the UI.
     * @param {object} message
     * @returns which means that the toast notification will automatically disappear after 5 seconds. 
     */
    showSuccessToastMessage: (message) => {
        om2alert(message, {
            type: "success",
            toast: true,
            closeTimeout: 5000,
        });
    },
    /**
     * Description `showInfoToastMessage` is a method of the `AlertMessagesService` object that takes a
     * `message` parameter. It uses the `om2alert` function from the `omni-campaign-ui` library to
     * display a info message as a toast notification on the UI.
     * @param {object} message
     * @returns which means that the toast notification will automatically disappear after 5 seconds. 
     */
    showInfoToastMessage: (message) => {
        om2alert(message, {
            type: "info",
            toast: true,
            closeTimeout: 5000,
        });
    },

    /**
     * Description `showWarningToastMessage` is a method of the `AlertMessagesService` object that takes a
     * `message` parameter. It uses the `om2alert` function from the `omni-campaign-ui` library to
     * display a warning message as a toast notification on the UI.
     * @param {object} message
     * @returns which means that the toast notification will automatically disappear after 5 seconds. 
     */
    showWarningToastMessage: (message) => {
        om2alert(message, {
            type: "warning",
            toast: true,
            closeTimeout: 5000,
        });
    },
}